<template>
  <responsive-drawer-header :color="color" :moduleUnreadCount="unreadCount">
    <template v-slot:drawer-module-title>{{ mx_moduleTitle }}</template>

    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>{{ displayedForm ? displayedForm.title : $t('forms.info.selected.none') }}</template>

    <template v-slot:right v-if="$route.params.formId !== undefined">
      <confirmation-dialog headerProp="search.closeDialog" textProp="module.wagenbuch.cancel_confirmation" @click="exitForm">
        <template v-slot:activator="{ on }">
          <v-btn :color="theme.appBar.other.color" icon v-on="on">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </confirmation-dialog>
    </template>
  </responsive-drawer-header>
</template>

<script>
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import ConfirmationDialog from '@/dialogs/ConfirmationDialog.vue';
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import config from '@/common/config';

export default {
  mixins: [common, configMixin],
  components: { ResponsiveDrawerHeader, ConfirmationDialog },

  computed: {
    ...mapState('forms', {
      formsById: (state) => state.formsById,
    }),
    unreadCount() {
      let { instance } = this.$route.params;
      return this.$store.getters[`forms/getUnreadCountByModuleInstance`](instance);
    },
    color() {
      return this.theme.appBar.other.color;
    },
    formId() {
      return this.$route.params.formId ? this.$route.params.formId : undefined;
    },
    displayedForm() {
      return this.formId && this.formsById[this.formId];
    },
    formUrl() {
      if (this.displayedform) {
        return `${config.apiUrl}/medias/forms/${this.displayedForm.filename}/${this.displayedForm.checksum}`;
      }
      return null;
    },
    isRead() {
      return this.displayedForm && this.displayedForm._userState && this.displayedForm._userState.dateread;
    },
  },
  methods: {
    //TODO: do not exit but display confirmation that form has been sent or pushed to sendbox
    exitForm() {
      this.removeFormInLocalStorage()
      this.$router.push('/forms/' + this.$route.params.instance);
    },
    removeFormInLocalStorage() {
      let storedForms = JSON.parse(localStorage.getItem('forms')||'{}')
      delete storedForms[this.formId];
      localStorage.setItem('forms',JSON.stringify(storedForms,null,2));
    }
  },
};
</script>
